export const VITEC = "vitec";
export const MSPECS = "mspecs";
export const KIVI = "kivi";
